import { useMemo } from 'react';

import { useTranslation } from '@shared/core/i18n';
import type { EmailsFooterTranslations } from './Emails.types';

export const useEmailsFooterTranslations = (): EmailsFooterTranslations => {
  const { tq } = useTranslation('emailsAndEcards');

  return useMemo(
    () => ({
      coupleNames: (nameA: string, nameB: string) => tq`${nameA} and ${nameB}`,
      sentFrom: (names: string) => tq`This message was sent from withjoy.com on behalf of ${names}.`,
      sendRepliesTo: (email: string) => tq`Send replies to ${email}.`,
    }),
    [tq],
  );
};
